"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechRuleEngine = exports.texToSpeechAsync = exports.mmlToSpeechAsync = exports.locales = void 0;
const engine_1 = __importDefault(require("speech-rule-engine/js/common/engine"));
const system_1 = require("speech-rule-engine/js/common/system");
const variables_1 = require("speech-rule-engine/js/common/variables");
const tex_to_mml_1 = require("./tex-to-mml");
// Setting delay stops SRE from setting itself up (and loading locales) when it
// is not actually being used.
engine_1.default.getInstance().delay = true;
// This is a map of locales that are supported by SRE. The keys are the locale
// codes and the values are the locale names.
exports.locales = variables_1.Variables.LOCALES;
/**
 * Sets up the speech rule engine with given options.
 * @param options Options to pass to the speech rule engine.
 * @returns A promise that resolves when the speech rule engine is ready: a string containing the locale.
 */
const setup = (() => {
    const cache = {};
    return async (locale) => {
        if (cache[locale] == null) {
            cache[locale] = await (0, system_1.setupEngine)({
                domain: "mathspeak",
                style: "verbose",
                locale: exports.locales.has(locale) ? locale : "en",
            });
        }
        return cache[locale];
    };
})();
const mmlToSpeechAsync = async (serializedMml, locale) => {
    await setup(locale); // result is cached, so should be fine to call multiple times
    return (0, system_1.toSpeech)(serializedMml);
};
exports.mmlToSpeechAsync = mmlToSpeechAsync;
const texToSpeechAsync = (tex, locale) => (0, exports.mmlToSpeechAsync)((0, tex_to_mml_1.texToMml)(tex), locale);
exports.texToSpeechAsync = texToSpeechAsync;
class SpeechRuleEngine {
    constructor(locale) {
        this.texToSpeech = (tex) => (0, system_1.toSpeech)((0, tex_to_mml_1.texToMml)(tex));
        if (typeof locale === "undefined") {
            throw new Error("Cannot be called directly");
        }
    }
    static async setup(locale) {
        const finalLocale = await setup(locale);
        return new SpeechRuleEngine(finalLocale);
    }
}
exports.SpeechRuleEngine = SpeechRuleEngine;
